import api from "./api";
const endpoint = "volontariat/AssociationCandidatController";

export const AssociationCandidatService = {
  async getAll(filtre) {
    try {
      const result = await api.get(endpoint + "/list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async downloadUploadedFileByAssociation(filtre) {
    try {
      const result = await api.get(
        endpoint + "/telecharger_association_pj",
        {
          params: filtre,
          responseType: "blob",
        }
      );
      
      if (result) {
        return result;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneByID(id) {
    try {
      const result = await api.get(endpoint + "/trouver", {
        params: { id_ext_asso_candida: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async offrePostuleesByidAssociation(id) {
    try {
      const result = await api.get(endpoint + "/offre_postulee", {
        params: { uuid: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async postuler(data) {
    try {
      const result = await api.post(endpoint + "/postuler", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateAssociationCandidat(data) {
    try {
      const result = await api.put(endpoint + "/modifier", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAssociationCandidatureByType(filtre) {
    try {
      const result = await api.get(
        endpoint + "/all_association_candidate_by_offer",
        {
          params: { filtre },
        }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      console.log("err update:", error);

      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAssociationStatus(filtre) {
    try {
      const result = await api.get(
        endpoint + "/status_association_candidate",
        {
          params: { filtre },
        }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
